import { render } from "./MainMenu.vue?vue&type=template&id=099a1b88&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=099a1b88&scoped=true&lang=css"

import exportComponent from "/Users/alexvoina/Development/myhouse-admin-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099a1b88"]])

export default __exports__